/**
 * This is the main entry point of the Javascript.
 * It initializes the necessary components.
 */

document.addEventListener("DOMContentLoaded", () => {

    const allEmptyLinks         = document.querySelectorAll('a[href="#"]');
    const allNotEmptyLinks      = document.querySelectorAll('a[href^="#"]');
    const header                = document.querySelector('.header');

    if(allEmptyLinks) {
        allEmptyLinks.forEach(link => {
            link.addEventListener('click', function(event) {
                event.preventDefault();
            });
        });
    }

    // Scroll smoothly to element with ID
    if (allNotEmptyLinks) {
        allNotEmptyLinks.forEach(anchor => {
            anchor.addEventListener('click', function (event) {
                event.preventDefault();

                const targetId = this.getAttribute('href');
                if (targetId && targetId.startsWith('#') && targetId.length > 1) {
                    const targetElement = document.querySelector(targetId);
                    console.log(targetElement)
                    if (targetElement) {
                        const yOffset = -100; // Odstęp 100px od góry
                        const yPosition = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

                        window.scrollTo({
                            top: yPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            });
        });
    }

    if(!header) {
        return;
    }

    const toggleHeaderClass = () => {
        if(window.scrollY > 0) {
            header.classList.add('scrolling');
        } else {
            header.classList.remove('scrolling');
        }
    };

    toggleHeaderClass();

    window.addEventListener('scroll', toggleHeaderClass);
});
